export default __webpack_public_path__ + "static/media/r200-6.440aa3fc.png";